import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable()
export class CompanyService {
    constructor(private http: HttpClient) {
    }

    public getAll(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http.get<any>(environment.apiUrl + 'company/getAll').subscribe(data => {
                resolve(data);
            }, error => {
                //console.log(error);
                reject();
            });
        });
  }
  public get(id): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.get<any>(environment.apiUrl + 'company/GetById?Id=' + id).subscribe(data => {
        resolve(data);
      }, error => {
        //console.log(error);
        reject();
      });
    });
  }
}
